/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import theApi from '@/mixins/theApi';

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload);
  },

  async tokenLogin(context, payload) {
    const appLoading = document.getElementById('loading-bg-full');
    appLoading.style.display = 'block';

    // Clear any data
    localStorage.removeItem('token');
    localStorage.removeItem('login_type');
    localStorage.removeItem('fname');
    localStorage.removeItem('lname');
    context.commit('setUser', {
      userID: '',
      token: '',
      email: '',
      fname: '',
      lname: '',
      prework: false,
      experiences: [],
      active_experience_id: false,
      settings: false,
      notifications: [],
      available_experiences: [],
      certificate_teachers: false,
      access_type: false,
    });

    let formData = new FormData();
    formData.append('token', payload.token);

    try {
      const res = await theApi.methods.makeCall(false, 'tokenLogin', 'post', formData, null, true);

      if (res.login_type === 'teacher') {
        localStorage.setItem('token', res.api_token);
        localStorage.setItem('login_type', res.login_type);
        localStorage.setItem('fname', res.fname);
        localStorage.setItem('lname', res.lname);
        context.commit('authStudent/setUser', {
          token: res.api_token,
          email: res.email,
          fname: res.fname,
          lname: res.lname,
          notifications: res.notifications,
        });
        window.location.href = '/teacher/dashboard';
        return;
      }

      if (res.login_type === 'student') {
        localStorage.setItem('token', res.api_token);
        localStorage.setItem('login_type', res.login_type);
        localStorage.setItem('fname', res.fname);
        localStorage.setItem('lname', res.lname);
        context.commit('authStudent/setUser', {
          token: res.api_token,
          fname: res.fname,
          lname: res.lname,
          email: res.email,
          school: res.school,
          prework: res.prework,
          experiences: res.experiences,
          settings: res.settings,
          notifications: res.notifications,
          available_experiences: res.available_experiences,
          certificate_teachers: res.certificate_teachers,
          ctWhsEnabled: res.ct_whs_enabled,
        });
        window.location.href = '/student/dashboard';
        return;
      }
    } catch (e) {
      //
    }
    appLoading.style.display = 'none';
  },
};

export default actions;
